module.exports = __webpack_public_path__ + "static/media/white_on_transparent.6b519e5f.png";